const onReady = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
      return;
    }
    fn();
  };

  // ============================================
  // Blog Category Filtering
  // ============================================
  const initBlogFilters = () => {
    const categoryChips = document.querySelectorAll(".blog-category-chip");
    const blogCards = document.querySelectorAll(".blog-card");
    const searchInput = document.getElementById("blogSearch");

    if (categoryChips.length === 0 || blogCards.length === 0) return;

    let activeCategory = "all";
    let searchQuery = "";

    const filterCards = () => {
      blogCards.forEach((card) => {
        const cardCategory = card.getAttribute("data-category") || "";
        const cardTitle = card.querySelector(".blog-card-title")?.textContent?.toLowerCase() || "";
        const cardExcerpt = card.querySelector(".blog-card-excerpt")?.textContent?.toLowerCase() || "";

        const matchesCategory = activeCategory === "all" || cardCategory === activeCategory;
        const matchesSearch = searchQuery === "" || 
                              cardTitle.includes(searchQuery) || 
                              cardExcerpt.includes(searchQuery);

        if (matchesCategory && matchesSearch) {
          card.style.display = "";
          card.style.opacity = "0";
          setTimeout(() => {
            card.style.opacity = "1";
          }, 50);
        } else {
          card.style.display = "none";
        }
      });
    };

    categoryChips.forEach((chip) => {
      chip.addEventListener("click", () => {
        categoryChips.forEach((c) => c.classList.remove("active"));
        chip.classList.add("active");
        activeCategory = chip.getAttribute("data-category") || "all";
        filterCards();
      });
    });

    if (searchInput) {
      searchInput.addEventListener("input", (e) => {
        searchQuery = e.target.value.toLowerCase().trim();
        filterCards();
      });
    }

    // Sticky filters on scroll
    const blogFilters = document.querySelector(".blog-filters");
    const blogGrid = document.querySelector(".blog-grid");
    const filtersContainer = blogFilters?.parentElement;
    
    if (blogFilters && blogGrid && filtersContainer) {
      const navbarHeight = 80;
      const filtersOffset = blogFilters.offsetTop;
      let isFixed = false;

      const handleScroll = () => {
        const scrollY = window.scrollY;
        
        if (scrollY >= filtersOffset - navbarHeight && !isFixed) {
          blogFilters.classList.add("is-fixed");
          blogFilters.style.width = `${filtersContainer.offsetWidth}px`;
          blogFilters.style.left = `${filtersContainer.getBoundingClientRect().left}px`;
          blogGrid.style.paddingTop = `${blogFilters.offsetHeight + 20}px`;
          isFixed = true;
        } else if (scrollY < filtersOffset - navbarHeight && isFixed) {
          blogFilters.classList.remove("is-fixed");
          blogFilters.style.width = "";
          blogFilters.style.left = "";
          blogGrid.style.paddingTop = "0";
          isFixed = false;
        }
      };

      window.addEventListener("scroll", handleScroll, { passive: true });
      window.addEventListener("resize", handleScroll, { passive: true });
      handleScroll(); // Check on load
    }
  };

  // ============================================
  // Comment Form Handling
  // ============================================
  const initCommentForm = () => {
    const commentForm = document.getElementById("commentForm");
    const commentsList = document.querySelector(".comments-list");

    if (!commentForm || !commentsList) return;

    commentForm.addEventListener("submit", (e) => {
      e.preventDefault();

      const nameInput = commentForm.querySelector('input[type="text"]');
      const emailInput = commentForm.querySelector('input[type="email"]');
      const textarea = commentForm.querySelector("textarea");

      const name = nameInput?.value?.trim() || "";
      const email = emailInput?.value?.trim() || "";
      const comment = textarea?.value?.trim() || "";

      if (!name || !email || !comment) return;

      // Get initials from name
      const initials = name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);

      // Create new comment element
      const commentItem = document.createElement("div");
      commentItem.className = "comment-item";
      commentItem.style.opacity = "0";
      commentItem.style.transform = "translateY(20px)";
      commentItem.style.transition = "opacity 300ms ease, transform 300ms ease";

      commentItem.innerHTML = `
        <div class="comment-header">
          <div class="comment-avatar">${initials}</div>
          <div class="comment-author">
            <div class="comment-name">${name}</div>
            <div class="comment-date">Just now</div>
          </div>
          <button class="comment-reply-btn">Reply</button>
        </div>
        <p class="comment-text">${comment}</p>
      `;

      // Add to comments list
      commentsList.insertBefore(commentItem, commentsList.firstChild);

      // Animate in
      setTimeout(() => {
        commentItem.style.opacity = "1";
        commentItem.style.transform = "translateY(0)";
      }, 50);

      // Reset form
      commentForm.reset();

      // Show success feedback
      const submitBtn = commentForm.querySelector(".comment-form-submit");
      const originalText = submitBtn.textContent;
      submitBtn.textContent = "Comment Posted!";
      submitBtn.style.background = "linear-gradient(135deg, #28a745, #20c997)";
      
      setTimeout(() => {
        submitBtn.textContent = originalText;
        submitBtn.style.background = "";
      }, 2000);
    });
  };

  // ============================================
  // Share Button Functionality
  // ============================================
  const initShareButtons = () => {
    const shareButtons = document.querySelectorAll(".article-share-btn");

    if (shareButtons.length === 0) return;

    shareButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const icon = btn.querySelector("i");
        const iconClass = icon?.className || "";

        if (iconClass.includes("twitter-x")) {
          const url = encodeURIComponent(window.location.href);
          const text = encodeURIComponent(document.querySelector(".article-title")?.textContent || "");
          window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, "_blank");
        } else if (iconClass.includes("linkedin")) {
          const url = encodeURIComponent(window.location.href);
          window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, "_blank");
        } else if (iconClass.includes("link-45deg")) {
          navigator.clipboard.writeText(window.location.href).then(() => {
            const originalHTML = btn.innerHTML;
            btn.innerHTML = '<i class="bi bi-check-lg"></i>';
            setTimeout(() => {
              btn.innerHTML = originalHTML;
            }, 2000);
          });
        }
      });
    });
  };

  // ============================================
  // Newsletter Form
  // ============================================
  const initNewsletterForm = () => {
    const newsletterForms = document.querySelectorAll(".newsletter-form");

    if (newsletterForms.length === 0) return;

    newsletterForms.forEach((form) => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();

        const input = form.querySelector(".newsletter-input");
        const btn = form.querySelector(".newsletter-btn");

        if (!input || !btn) return;

        const email = input.value.trim();
        if (!email) return;

        // Show success state
        const originalText = btn.textContent;
        btn.textContent = "Subscribed!";
        btn.style.background = "linear-gradient(135deg, #28a745, #20c997)";
        input.value = "";
        input.placeholder = "Thank you for subscribing!";

        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = "";
          input.placeholder = "Enter your email";
        }, 3000);
      });
    });
  };

  // ============================================
  // Reply Button Functionality
  // ============================================
  const initReplyButtons = () => {
    const replyButtons = document.querySelectorAll(".comment-reply-btn");

    if (replyButtons.length === 0) return;

    replyButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const commentForm = document.getElementById("commentForm");
        const textarea = commentForm?.querySelector(".comment-form-textarea");

        if (textarea) {
          textarea.focus();
          textarea.value = "@Replying to comment...\n\n";
          textarea.setSelectionRange(28, 28);
        }
      });
    });
  };

  // ============================================
  // Featured Slider
  // ============================================
  const initFeaturedSlider = () => {
    const track = document.querySelector("[data-featured-slider]");
    if (!track) return;

    const originalCards = Array.from(track.querySelectorAll(".featured-slider-card"));
    if (originalCards.length === 0) return;

    const prevBtn = document.querySelector("[data-featured-prev]");
    const nextBtn = document.querySelector("[data-featured-next]");

    // Clone cards for infinite loop
    const cloneCount = 1;
    const firstCards = originalCards.slice(0, cloneCount);
    const lastCards = originalCards.slice(-cloneCount);

    lastCards.reverse().forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add("is-clone");
      track.insertBefore(clone, track.firstChild);
    });

    firstCards.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add("is-clone");
      track.appendChild(clone);
    });

    const cards = Array.from(track.querySelectorAll(".featured-slider-card"));
    const originalCount = originalCards.length;
    const cardWidth = originalCards[0].offsetWidth + 12; // width + gap
    const realStart = cloneCount * cardWidth;
    const realEnd = (cloneCount + originalCount) * cardWidth;
    const totalWidth = originalCount * cardWidth;

    // Start at first real card
    track.scrollLeft = realStart;

    let isNavigating = false;

    const scrollToIndex = (delta) => {
      if (isNavigating) return;
      isNavigating = true;

      const currentPos = track.scrollLeft;
      const targetPos = currentPos + delta * cardWidth;

      const prefersReduced = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;

      if (delta > 0 && targetPos >= realEnd) {
        const offset = targetPos - realEnd;
        track.scrollTo({ left: realStart + offset, behavior: "auto" });
      } else if (delta < 0 && targetPos < realStart) {
        const offset = realStart - targetPos;
        track.scrollTo({ left: realEnd - offset, behavior: "auto" });
      } else {
        track.scrollTo({ left: targetPos, behavior: prefersReduced ? "auto" : "smooth" });
      }

      setTimeout(() => { isNavigating = false; }, prefersReduced ? 50 : 400);
    };

    if (prevBtn) {
      prevBtn.addEventListener("click", () => scrollToIndex(-1));
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => scrollToIndex(1));
    }

    // Touch/drag support
    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener("mousedown", (e) => {
      isDown = true;
      track.style.cursor = "grabbing";
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener("mouseleave", () => {
      isDown = false;
      track.style.cursor = "grab";
    });

    track.addEventListener("mouseup", () => {
      isDown = false;
      track.style.cursor = "grab";
      setTimeout(() => {
        if (track.scrollLeft >= realEnd) {
          track.scrollLeft = track.scrollLeft - totalWidth;
        } else if (track.scrollLeft < realStart) {
          track.scrollLeft = track.scrollLeft + totalWidth;
        }
      }, 50);
    });

    track.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 2;
      track.scrollLeft = scrollLeft - walk;
    });

    track.style.cursor = "grab";
  };

  // ============================================
  // Article Header Sticky State
  // ============================================
  const initArticleHeaderStickyState = () => {
    const header = document.querySelector(".article-header");
    if (!header) return;

    const stickyTop = 96;

    const updateStuckState = () => {
      const rect = header.getBoundingClientRect();
      header.classList.toggle("is-stuck", rect.top <= stickyTop);
    };

    window.addEventListener("scroll", updateStuckState, { passive: true });
    updateStuckState();
  };

  // ============================================
  // Smooth Scroll for Back to Blog
  // ============================================
  const initBackToBlog = () => {
    const backLinks = document.querySelectorAll('a[href="blog.html"]');

    backLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        // Let the default navigation happen
        // This is just a placeholder for any additional logic
      });
    });
  };

  // ============================================
  // Initialize All Blog Functionality
  // ============================================
  onReady(() => {
    initBlogFilters();
    initCommentForm();
    initShareButtons();
    initNewsletterForm();
    initReplyButtons();
    initFeaturedSlider();
    initArticleHeaderStickyState();
    initBackToBlog();
  });
